<template>
  <v-icon v-if="isLoading" class="pr-1">
    mdi-spin mdi-sync
  </v-icon>

  <BTooltipButton
    v-else-if="show"
    :color="action.color"
    :to="to"
    :href="href"
    :target="action.target"
    :icon="action.icon"
    :text="action.text"
    :tooltip="action.tooltip"
    :class-button="`js-action--${action.action}`"
    depressed
    small
    tile
    top
    @click="onAction"
  />
</template>

<script>
import { TableActionsTypes } from '@/helpers/enums/table-actions'
import BTooltipButton from '@/components/common/BTooltipButton.vue'


export default {
  name: 'BTableButtonAction',
  components: {
    BTooltipButton,
  },
  props: {
    action: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
      default: () => 0,
    },
    data: {
      type: Object,
      required: true,
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    to: void 0,
    href: void 0,
    filter: void 0,
    isLoading: false,
  }),
  computed: {
    show() {
      const { data, index, list } = this
      return this.filter ? this.filter(data, index, list) : true
    },
  },
  watch: {
    data: {
      immediate: true,
      handler: 'onUpdateData',
    },
  },
  methods: {
    onAction() {
      const { data } = this
      const { action } = this.action

      switch (action) {
        case TableActionsTypes.sortable_positions_down:
        case TableActionsTypes.sortable_positions_up: {
          const direction = action === TableActionsTypes.sortable_positions_down ? 1 : -1
          const oldIndex = this.list.indexOf(data)
          const newIndex = oldIndex + direction
          this.$emit('change:positions', oldIndex, newIndex, this.toggleLoading)
          break
        }

        default:
      }

      this.$emit(`action:${action}`, data, this.toggleLoading)
      this.$emit('action', action, data, this.toggleLoading)
    },
    onUpdateData() {
      const { action, data } = this
      this.to = action.getRoute && action.getRoute(data)
      this.href = action.getHref && action.getHref(data)
      this.filter = action.getFilter
    },
    toggleLoading() {
      this.isLoading = !this.isLoading
      return this.toggleLoading
    },
  },
}
</script>

<style lang="scss">

.js-action {
  &--sortable-positions-up {
    .b-table tr:first-child & {
      pointer-events: none;
      opacity: 0.5;
    }
  }

  &--sortable-positions-down {
    .b-table tr:last-child & {
      pointer-events: none;
      opacity: 0.5;
    }
  }
}
</style>
